// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"09bda013","977":"93f1455e"}[chunkId] + ".chunk.js";
};